<template>
  <div class="accountManagement">

    <!-- 查询区内容 -->
    <div class="queryArea">
      <!-- <el-input v-model="parameter.acounnt_id" placeholder="acounnt_id" class="queryArea_input" /> -->
      <el-input v-model="parameter.openId" placeholder="请输入openId" class="queryArea_input" />
      <!-- <el-input v-model="parameter.nickName" placeholder="请输入名称" class="queryArea_input" /> -->
      <el-select
        v-model="parameter.platformId"
        class="launch"
        filterable
        placeholder="选择平台"
      >
        <el-option
          v-for="item in platforms"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left:10px"
        @click="searchar"
      >搜索</el-button>
      <el-button
        type="info"
        icon="el-icon-refresh"
        @click="reset"
      >重置</el-button>
      <!-- <el-button icon="el-icon-circle-plus" type="success" @click="establish">创建</el-button> -->
    </div>

    <!-- 列表内容 -->
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      tooltip-effect="dark"
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="ranking"
        label="排名"
        width="80"
        align="center"
      />
      <el-table-column
        prop="rankingText"
        label="昵称"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="昵称"
            width="200"
            trigger="hover"
            :content="scope.row.rankingText"
          >
            <p slot="reference" class="titip">{{ scope.row.rankingText }}</p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        label="头像"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <img style="width:50px;height:50px" :src="scope.row.rankingAvatar" alt="">
        </template>
      </el-table-column>
      <el-table-column
        prop="openId"
        label="openId"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="openId"
            width="200"
            trigger="hover"
            :content="scope.row.openId"
          >
            <p slot="reference" class="titip">{{ scope.row.openId }}</p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="orderAmount"
        label="订单总额"
        width="150"
        align="center"
      />
      <el-table-column
        prop="platName"
        label="平台"
        width="150"
        align="center"
      />
      <el-table-column
        prop="bookCurrency"
        label="书币金额"
        width="150"
        align="center"
      />
      <el-table-column
        prop="readTotal"
        label="总阅读数"
        width="150"
        align="center"
      />
      <el-table-column
        prop="activeDay"
        label="活跃天数"
        width="150"
        align="center"
      />
      <el-table-column
        prop="promotionRank"
        label="排名提升"
        align="center"
      />
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <addranklist />
    </el-dialog>
  </div>
</template>

<script>
import addranklist from './components/establishdialog.vue'
import { rankinglist, strategyPlatform } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    addranklist,
    PaginationRight
  },
  data() {
    return {
      parameter: {
        nickName: null,
        openId: null,
        platformId: null,
        page: 1,
        pageSize: 10
      },
      total: null,
      platforms: [], // 平台数据
      tableData: [], // 列表数据
      dialogVisible: false // 新增排行榜弹窗
    }
  },
  watch: {

  },
  created() {
    this.strategylist()
    this.ranklist()
  },
  mounted() {

  },
  methods: {
    establish() {
      this.dialogVisible = true
    },
    // 排行榜列表
    async ranklist() {
      const data = await rankinglist(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 获取策略列表
    async strategylist() {
      const data = await strategyPlatform()
      this.platforms = data.data.list
    },
    // 分页
    fetchPageSize(e) {
      this.parameter.pageSize = e
      this.getweatlas()
    },
    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getweatlas()
    },
    searchar() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.ranklist()
    },
    reset() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.parameter.nickName = null
      this.parameter.openId = null
      this.parameter.platformId = null
      this.ranklist()
    }
  }
}
</script>
<style scoped>
.accountManagement{
   padding: 30px 60px;
}

.queryArea_input{
  width: 150px;
  margin-right: 10px;
}
.titip{
    width: 152px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    overflow: hidden;
}
</style>
